import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import {
  GeothermalInstallPackageFileCategory,
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

export const SystemPhotos = ({
  showCheckboxes,
  checkboxCategories,
}: {
  showCheckboxes: boolean;
  checkboxCategories: GeothermalInstallPackageFileCategory[];
}) => {
  return (
    <>
      <FormSection
        title="New System Photos"
        description={
          <>
            <Box>Upload photos to all applicable categories.</Box>
            <Box>
              Reference <Link to={''}>Install Photo Requirements documentation</Link> for specifics on submission
              requirements.
            </Box>
          </>
        }
      >
        <PhotosList
          title="Equipment Data Plate"
          description="Photo must show manufacturer's data plate with serial number, model number, and capacity rating clearly visible"
          category={InstallationPackagePhotoCategory.equipmentDataPlate}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.equipmentDataPlateGeothermal}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.geothermal}
        />
        <PhotosList
          title="Mechanical Room Wide Shot"
          description="Photo must show the complete heat pump unit and surrounding installation area, including connections, clearances, and piping"
          category={InstallationPackagePhotoCategory.mechanicalRoomWideShot}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.mechanicalRoomWideShotGeothermal}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.geothermal}
        />
        <PhotosList
          title="Flow Center"
          description="Photo must show flow center / circulator installation with connections to loop field and indoor unit"
          category={InstallationPackagePhotoCategory.flowCenter}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.flowCenterGeothermal}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.geothermal}
        />
        <PhotosList
          title="Loop Field Photo"
          description="Photo must show loop field installation, ideally before backfill"
          category={InstallationPackagePhotoCategory.loopFieldPhoto}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.loopFieldPhotoGeothermal}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.geothermal}
        />
        <PhotosList
          title="Electrical Disconnect"
          description="Photo must show electrical disconnect for the geothermal system, properly installed and accessible"
          category={InstallationPackagePhotoCategory.electricalDisconnect}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.electricalDisconnectGeothermal}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.geothermal}
        />
        <PhotosList
          title="Thermostat"
          description="Photo must show thermostat installed and configured for geothermal system operation"
          category={GeothermalInstallPackageFileCategory.thermostat as unknown as InstallationPackagePhotoCategory}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.thermostatGeothermal}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.geothermal}
        />
      </FormSection>
    </>
  );
};
